<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon points="10,3 9,2 6,5 3,2 2,3 5,6 2,9 3,10 6,7 9,10 10,9 7,6" />
</svg>
</template>